import { AnyAction } from 'redux';
import produce from 'immer';
import { VISITOR_REGISTER_DISPATCH, VISITOR_REGISTER_DISPATCH_INIT } from '../../actions';

export type ContentsInfo = {
  contentsId: number; // コンテンツコード
  eqsId: number; // 設備シフトID
  contentsDate: string; // コンテンツ日付
  startTime: string; // コンテンツ開始時間
  endTime: string; // コンテンツ終了時間
  companion: number; // 同行者数
  contentsName: string; // コンテンツ名
  shopName: string; // 店舗名
  eqsName: string; // 設備シフト名
  spaceName: string; // 設備設置席名称
  isAnnex: boolean; // 別館フラグ
  clubAddress: string | null; // クラブ住所
};

export type VisitorRegisterType = {
  contentsInfo: ContentsInfo;
};

const initialState: VisitorRegisterType = {
  contentsInfo: {
    contentsId: 0,
    eqsId: 0,
    contentsDate: '',
    startTime: '',
    endTime: '',
    companion: 0,
    contentsName: '',
    shopName: '',
    eqsName: '',
    spaceName: '',
    isAnnex: false,
    clubAddress: '',
  },
};

const visitorRegisterReducer = (state = initialState, action: AnyAction): VisitorRegisterType => {
  return produce(state, (draft) => {
    const dataState = draft;
    switch (action.type) {
      case VISITOR_REGISTER_DISPATCH:
        dataState.contentsInfo.contentsId = action.data.contentsId;
        dataState.contentsInfo.eqsId = action.data.eqsId;
        dataState.contentsInfo.contentsDate = action.data.contentsDate;
        dataState.contentsInfo.startTime = action.data.startTime;
        dataState.contentsInfo.endTime = action.data.endTime;
        dataState.contentsInfo.companion = action.data.companion;
        dataState.contentsInfo.contentsName = action.data.contentsName;
        dataState.contentsInfo.shopName = action.data.shopName;
        dataState.contentsInfo.eqsName = action.data.eqsName;
        dataState.contentsInfo.spaceName = action.data.spaceName;
        dataState.contentsInfo.isAnnex = action.data.isAnnex;
        dataState.contentsInfo.clubAddress = action.data.clubAddress;
        break;
      case VISITOR_REGISTER_DISPATCH_INIT:
        dataState.contentsInfo.contentsId = initialState.contentsInfo.contentsId;
        dataState.contentsInfo.eqsId = initialState.contentsInfo.eqsId;
        dataState.contentsInfo.contentsDate = initialState.contentsInfo.contentsDate;
        dataState.contentsInfo.startTime = initialState.contentsInfo.startTime;
        dataState.contentsInfo.endTime = initialState.contentsInfo.endTime;
        dataState.contentsInfo.companion = initialState.contentsInfo.companion;
        dataState.contentsInfo.contentsName = initialState.contentsInfo.contentsName;
        dataState.contentsInfo.shopName = initialState.contentsInfo.shopName;
        dataState.contentsInfo.eqsName = initialState.contentsInfo.eqsName;
        dataState.contentsInfo.spaceName = initialState.contentsInfo.spaceName;
        dataState.contentsInfo.isAnnex = initialState.contentsInfo.isAnnex;
        dataState.contentsInfo.clubAddress = initialState.contentsInfo.clubAddress;
        break;
      default:
        break;
    }
  });
};

export default visitorRegisterReducer;
